import { saveAs } from 'file-saver';

/**
 * Download a blob response as a file.
 * Uses file-saver for reliable cross-browser downloads.
 */
export function downloadBlob(blobData, filename) {
  // Ensure we have a proper Blob with correct MIME type
  const blob = blobData instanceof Blob
    ? blobData
    : new Blob([blobData], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });

  saveAs(blob, filename);
}
